export default __webpack_public_path__ + "static/media/virgen_de_guadalupe.144e73d8.jpeg";